'use client'

import React from 'react'
import classNames from 'classnames'
import { CardType } from '@/ui/components/Card/types'
import { getGridColumnClass } from '@/ui/components/CollectionArchive/ArchiveContent/ItemsGrid/index'
import { cn } from '@/utils/ui'
import { StandardCardSkeleton } from '@/ui/components/Card/StandardCard/StandardCardSkeleton'
import { StandardFavoriteCardSkeleton } from '@/ui/components/Card/StandardCard/StandardFavoriteCardSkeleton'
import { TeaserCardSkeleton } from '@/ui/components/Card/TeaserCard/TeaserCardSkeleton'
import { ResourceCardSkeleton } from '@/ui/components/Card/ResourceCard/ResourceCardSkeleton'

type ItemsGridSkeletonProps = {
  cardType: CardType
  gridCols: 1 | 2 | 3 | 4
  limit?: number
  className?: string
  showImage?: boolean
}

export const ItemsGridSkeleton: React.FC<ItemsGridSkeletonProps> = ({
  cardType,
  gridCols,
  limit,
  className: classNameFromProps,
  showImage = true,
}) => {
  const renderCard = (item: CardType) => {
    switch (item) {
      case CardType.Standard:
        return <StandardCardSkeleton />
      case CardType.StandardFavorite:
        return <StandardFavoriteCardSkeleton showImage={showImage} />
      case CardType.Teaser:
        return <TeaserCardSkeleton />
      case CardType.Resource:
        return <ResourceCardSkeleton />
      default:
        return null
    }
  }

  return (
    <div className={classNames(classNameFromProps, '@container/grid')}>
      <div className={cn('grid gap-6', getGridColumnClass(gridCols))}>
        {Array.from({ length: limit ?? 10 }).map((_, index) => (
          <div key={index}>{renderCard(cardType)}</div>
        ))}
      </div>
    </div>
  )
}
